import React from 'react';

import { Line } from 'react-chartjs-2'


import ChartCard from './ChartCard';


class LineGraph extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }





  componentWillMount() {
  }



  render () {



  const { title, icon, textData, seriesData, graphLabels, statText, weeklyOrderCount } = this.props;

  const lineGraphConfig = {
    labels: graphLabels,
    datasets: [
      {
        label: 'Revenue',
        type:'line',
        backgroundColor: '#bac2ff',
        borderColor: '#bac2ff',
        borderWidth: 1,
        hoverBackgroundColor: '#bac2ff',
        hoverBorderColor: '#bac2ff',
        data: seriesData,
        yAxisID: 'y-axis-1'
      }, {
        type: 'line',
        label: 'Number of Orders',
        data: weeklyOrderCount,
        backgroundColor: '#4e91fd',
        borderColor: '#4e91fd',
        hoverBackgroundColor: '#4e91fd',
        hoverBorderColor: '#4e91fd',
        yAxisID: 'y-axis-2'
      }
    
    
    
    
    ]

  }

    


    const options = {
      responsive: true,
      labels: graphLabels,
    maintainAspectRatio: true,
      tooltips: {
        mode: 'label'
      },
      elements: {
        line: {
          fill: false
        }
      },

      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              display: false
            },
       labels: graphLabels,
     
          }

        ],
        yAxes: [
          {
            ticks: {
              callback: function(label, index, labels) {
                  return label/1000+'k';
              }
          },
          scaleLabel: {
            display: true,
            labelString: 'Revenue (NZD)'
          },
            type: 'linear',
            display: true,
            position: 'left',
            id: 'y-axis-1',
            gridLines: {
              display: false
            },
            labels: {
              show: true,

            }
          },
          {
            scaleLabel: {
              display: true,
              labelString: 'Number of Orders'
            },
            type: 'linear',
            display: true,
            position: 'right',
            id: 'y-axis-2',
            gridLines: {
              display: false
            },
            labels: {
              show: true
              
            }
          }
        ]
      }
    };



   

    return (


     


      <ChartCard
        chart={
          <Line
          data={lineGraphConfig}
          // options={options}
          width={350}
          height={140}
          options={options}
        />


        }
        chartColor="white"
        title={title}
        text={textData}
        statIcon={icon}
        statText={statText}
      />

  );
}
}


export default LineGraph;


// WEBPACK FOOTER //
// ./src/components/LIneGraph.jsx